import template from './same-name-tour.html';
import { GoTour, GoTourService, goTourServiceToken } from 'go-modules/go-tour/go-tour.service';
import dayjs from 'dayjs';
import { Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PlacementEngine, placementEngineToken } from 'go-modules/go-tour/placement-engine.factory';

@Injectable({
	providedIn: 'root'
})
export class SameNameTourService {
	public readonly startDate = dayjs('2023-09-21 12:00:00').toDate();
	public readonly title = 'same-name-tour_title' as const;
	public readonly viewTrackKey = 'same-name-tour' as const;
	public readonly selector = '.header-menu .user-menu' as const;
	private tour: GoTour;

	public constructor (
		@Inject(goTourServiceToken) private goTour: GoTourService,
		private translateFilter: TranslateService,
		@Inject(placementEngineToken) private placementEngine: PlacementEngine
	) {}

	public getTour (): GoTour {
		const placement = this.placementEngine.POSITION.RIGHT;
		const title = this.translateFilter.instant(this.title);
		if (!this.tour) {
			this.tour = this.goTour.defineTour({
				noArrow: true,
				viewTrackKey: this.viewTrackKey,
				constraints: {
					isOnboarding: false,
					tourStartDate: this.startDate
				},
				tourStepClass: this.viewTrackKey,
				steps: [
					{
						tourTitleAriaLabel: title,
						title,
						template,
						selector: this.selector,
						placement
					}
				]
			});
		}

		return this.tour;
	}
}
